import React from 'react';
//import React, { useEffect } from 'react';


import FormField from './FormField/FormField';
import Button from '../../Button/Button';

import checkValidity from './checkValidity';

import styles from './FormGenerator.module.css';


const FormGenerator = (props) => {
  const isValid = false;

  let submitButton = null;
  if (props.onSubmit) {
    submitButton = <>
                    <div className={styles.Break}></div>
                    <div className={styles.InputContainer}>
                      <Button btnType="Success" 
                              disabled={!props.isValid}>{props.submitButtonLabel || props.label || 'Submit'}
                      </Button>
                    </div>
                   </>
  }

  let form = (
    <form onSubmit={props.onSubmit}>
      <div className={styles.formcontainer}>
        {Object.keys( props.entries ).map( key => (
          <FormField
            key={key}
            name={key}
            className={props.entries[key].classname}
            containerClasses={props.entries[key].containerclasses}
            labelClasses={props.entries[key].labelclasses}
            inputClasses={props.entries[key].inputclasses}
            tag={props.entries[key].tag}
            label={props.entries[key].label}
            attributes={props.entries[key].attributes}
            shouldValidate={props.entries[key].validation}
            errorMessage={props.entries[key].errorMessage}
            selectOptions={props.entries[key].selectOptions}
            invalid={!props.state[key].valid}
            value={props.state[key].value}
            touched={props.state[key].touched}
            onChange={(event) => props.onChange(event, key)} 
          />
        ))}
        {submitButton}
      </div>
    </form>
  )

  return (
    <div className={styles.formcontainer}>
      {form}
    </div>
  )
}

const initFormState = (entries) => {

  let init = {};

  Object.keys( entries ).forEach( key => {
    let initValue = '';
    if (entries[key].tag === 'select') {
      initValue = entries[key].selectOptions[0].value ?? entries[key].selectOptions[0]
    }
    if (entries[key].tag === 'boxes') {
      initValue = entries[key].checked ?? []
    }
    if (entries[key].attributes && entries[key].attributes.type === 'date') {
      initValue = new Date().toISOString().slice(0, 10)
    }
    init[key] = {};
    init[key]['value']     = entries[key]['value'] ?? initValue;
    init[key]['initValue'] = entries[key]['value'] ?? initValue;
    init[key]['initLabel'] = entries[key]['label'] ?? '';
    init[key]['touched']   = false;
    init[key]['valid']     = !entries[key]['validation'];
    init[key]['message']   = '';    
  });
  return init;

} // initFormState


const extractValuesFromStore = ( slice ) =>
  Object.fromEntries(Object.entries( slice )
  .filter( ([k,v]) => !k.startsWith('X'))
  .map( ([k,v]) => [k,v.value] )); 
// extractValuesFromStore

FormGenerator.initFormState = initFormState;
FormGenerator.extractValuesFromStore = extractValuesFromStore;

export default FormGenerator;


/*
props: 
entries
name
onChange
onSubmit
submitButtonLabel
*/

/*
<div containerclasses>
  <div><label labelclasses></div>
  <div inputclasses><input classnames></div>
</div>
entries = {
    fieldname: {
        tag: 'input' | 'select' | 'textarea' | 'boxes' ,
        label:
        classname: 'class1 class2', JaNein
        containerclasses: TwoCols
        labelclasses: not yet
        inputclasses: not yet
        attributes: {       (=attributes to html input)
            type: 'text' | 'email' 
            type: ('text') | 'checkbox' | 'radio' | 'switch'  => for boxes
            options: ['foo', 'bar', {label:'a long label', value: 'baz'}], => for boxes
            checked: ['foo', 'bar'] => for checkboxes
            placeHolder: 
        },
        selectOptions: [ { value: '', displayValue '' } ],  => for select
        validation: {
            required: true | false
            minLength
            maxLength
            isNumeric
        },
        errorMessage: '',
        errorMessages: { validation: 'error' },    // not yet
        value:
    }
    ...
}

special entries:
Xlinebreak...: {}
Xsmallskip...:{}
Xmedskip...:{}
Xbigskip...:{}
Xtext...:{ value: "text" }
...: unique ID
*/